import styled from 'styled-components';
import { tooltipStyles } from '../tooltipBasic/tooltipBasic.styles';

export const TooltipWrapper = styled.div`
  pointer-events: none;
  ${tooltipStyles}
`;
